import type { Role } from '@/types';

/** Internal operational access to the Requests module (Installations tab). Mirrors ORDERS_ROLES:
 *  Dealer and Field Installer are denied (ADR-0001; ADR-0018). The Field Installer's
 *  assigned-installs view is a separate later story. */
export const REQUESTS_ROLES: Role[] = ['super_admin', 'admin', 'operational_associate'];

/** Human page name surfaced in the access-denied toast (ADR-0014). */
export const REQUESTS_PAGE_NAME = 'Requests Management';

export const INSTALLATION_REJECTED_MESSAGE = 'Installation request rejected successfully.';
export const INSTALLATION_APPROVED_MESSAGE = 'Installation request approved successfully.';

export const REPLACEMENT_REJECTED_MESSAGE = 'Replacement request rejected successfully';
export const REPLACEMENT_APPROVED_MESSAGE = 'Replacement request approved successfully';

/** `<DataTable>`/`useListFilters` id for the warranty queue — also the root of the list query key
 *  the decision mutations invalidate, so page and hook must agree on one value (ADR-0009). */
export const WARRANTY_TABLE_ID = 'warranty';

/** The only feedback a decision gives the admin. Customer SMS/in-app delivery is fire-and-forget:
 *  the BA confirmed on 110179 (2026-07-28) that a delivery failure is never surfaced to the admin,
 *  so there is no notification-failure toast (ticket 04/05 AC6 retired). Neither string carries the
 *  trailing period Figma draws — the ACs win. */
export const WARRANTY_CLAIM_REJECTED_MESSAGE = 'Warranty claim rejected successfully';
export const WARRANTY_CLAIM_APPROVED_MESSAGE = 'Warranty claim approved successfully';
